import React, { useState } from 'react';
import { Redirect } from 'react-router';
import { Add, ExpandMore } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { providerSuperviseeRoute, ROUTING_CONFIG } from '@uplift/constants';
import { useCollaboratePhysicianMatchQuery } from '@uplift/queries';
import { Button, Menu, MenuItem, ProviderLayout, ScrollableView, SupervisionMeetingDetailModal } from '@uplift/ui-v2';

import { ActivityFeed } from './components/ActivityFeed';
import { SuperviseeDetails } from './components/SuperviseeDetails';
import { SupervisionMeetingFormModal } from './components/SupervisionMeetingFormModal';


export const SuperviseeDetailsPageContent: React.VFC = () => {
  const { superviseeId } = providerSuperviseeRoute.useParams();
  const { data: collaborativeMatch } = useCollaboratePhysicianMatchQuery(superviseeId);
  const [ meetingModalOpen, setMeetingModalOpen ] = useState(false);
  const [ selectedMeetingId, setSelectedMeetingId ] = useState<string | null>(null);
  const [ modalOpened, setModalOpened ] = useState<'meetingDetails' | null>(null);

  if (!collaborativeMatch) {
    return <Redirect to={ROUTING_CONFIG.supervisees} />;
  }

  return (
    <>
      <Box sx={{ display: 'flex', flex: 1 }}>
        <Box sx={{ width: 420, borderRight: 1, borderColor: 'divider', backgroundColor: 'background.paper' }}>
          <SuperviseeDetails collaborativeMatchId={superviseeId} />
        </Box>
        <ScrollableView>
          <Box sx={{ padding: '48px 40px', display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h5" fontWeight={450}>Activity</Typography>
              <Menu
                renderAnchor={({ onClick }) => (
                  <Button variant="contained" color="secondary" startIcon={<Add />} endIcon={<ExpandMore />} onClick={onClick}>
                    Add Activity
                  </Button>
                )}
              >
                <MenuItem onClick={() => setMeetingModalOpen(true)}>
                  Supervision Meeting
                </MenuItem>
              </Menu>
            </Box>
            <ActivityFeed
              superviseeId={superviseeId}
              onSelectMeeting={meetingId => {
                setSelectedMeetingId(meetingId);
                setModalOpened('meetingDetails');
              }}
            />
          </Box>
        </ScrollableView>
      </Box>
      <SupervisionMeetingFormModal
        open={meetingModalOpen}
        onClose={() => setMeetingModalOpen(false)}
        collaborativeMatchId={superviseeId}
      />
      <SupervisionMeetingDetailModal
        open={modalOpened === 'meetingDetails'}
        onClose={() => setModalOpened(null)}
        onClosed={() => setSelectedMeetingId(null)}
        meetingId={selectedMeetingId}
        collaborativeMatchId={superviseeId}
      />
    </>
  );
};

export const SuperviseeDetailsPage: React.VFC = () => {
  return (
    <ProviderLayout bodyScroll={false}>
      <SuperviseeDetailsPageContent />
    </ProviderLayout>
  );
};
